document.addEventListener('DOMContentLoaded', () => {
  const containers = document.querySelectorAll('.product-description-container');
  const goToFAQLink =
    document.querySelector("a[href='#shopify-section-faq-section-AB']") ||
    document.querySelector("a[href='#shopify-section-e-sim-faq']");
  if (goToFAQLink) {
    goToFAQLink.setAttribute('href', '#faq-section');
    goToFAQLink.addEventListener('click', (e) => {
      e.preventDefault();
      document.getElementById('faq-section').scrollIntoView({
        behavior: 'smooth',
      });
    });
  }

  containers.forEach((container) => {
    const tabTitles = container.querySelectorAll('.product-tab-title');
    const tabDescriptions = container.querySelectorAll('.tab-description');
    const seeCoverageButtons = container.querySelectorAll('.span_coverage');

    seeCoverageButtons.forEach((el) => {
      if (el.tagName.toLowerCase() === 'span') {
        el.querySelector('u').textContent = '(See Country List)';
      }
    });

    if (!tabTitles.length) return;

    const activateTab = (tab) => {
      const targetId = `${tab.id}-description`;
      const targetDescription = container.querySelector(`#${targetId}`);

      // Deactivate all tabs in *this* container
      tabTitles.forEach((t) => t.classList.remove('tab-active'));
      tabDescriptions.forEach((desc) => {
        desc.classList.remove('description-active');
        desc.setAttribute('aria-selected', 'false');
      });

      // Activate selected tab + description
      tab.classList.add('tab-active');
      if (targetDescription) {
        targetDescription.classList.add('description-active');
        targetDescription.setAttribute('aria-selected', 'true');
      }

      tab.parentElement.scrollTo({
        left: tab.offsetLeft - 20,
        behavior: 'smooth',
      });
    };

    // Add click handlers within this container
    tabTitles.forEach((tab) => {
      tab.addEventListener('click', () => activateTab(tab));
    });

    seeCoverageButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const thirdTab = tabTitles[2];
        if (thirdTab) activateTab(thirdTab);
      });
    });
  });
});
